// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"23":"55d3951bb2631a33d83c","793":"03c557ef33bf671bb81f","980":"01de27da3e298278b481"}[chunkId] + ".js";
};